export const COLORS = {
  grey: "#333",
  green: "#2FBE34",
  orange: "#FF922E",
  red: "#FF3030"
};
